import { useNavigate } from "react-router-dom"

export const ProjectUnit = ({
    project,
    imageUrl,
    description,
    pointsArray
}) => {

    const navigateTo = useNavigate();

    return (
        <div className="project-unit-box">
            <div
                className="project-unit-img"
                style={{ backgroundImage: `linear-gradient(#000000, #000000)` }}
            >
                <img
                    src={imageUrl}
                    alt=""
                    className="project-pic"
                    loading="lazy"
                />
                <div className="city-name">{project}</div>
            </div>
            <div className="project-unit-descr">{description}</div>
            <div className="order-button-container flx-rw c-jt">
                <button
                    className="order-button"
                    onClick={() => navigateTo("/contact",{state: {project}}) }
                >
                    Jetzt anfragen
                </button>
            </div>
        </div>
    )
}